import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  AdminOrderResponse,
  getAdminPayOutOrdersApi,
  AdminPayPutOrdersRequest,
  AdminPayOutOrder,
  completePayOutOrderApi,
  cancelPayOutOrderBySupportApi,
} from "./api";
import { State } from "@features/base/types";

export const getAdminPayOutOrders = createAsyncThunk<
  AdminOrderResponse | null,
  { data?: AdminPayPutOrdersRequest }
>(
  "adminPayOutOrders/getAdminPayOutOrders",
  async ({ data }, { rejectWithValue }) => {
    try {
      return await getAdminPayOutOrdersApi(data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const completePayOutOrder = createAsyncThunk<
  string,
  { orderId: string }
>(
  "adminPayOutOrders/completePayOutOrder",
  async ({ orderId }, { rejectWithValue }) => {
    try {
      return await completePayOutOrderApi(orderId);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const cancelPayOutOrderBySupport = createAsyncThunk<
  string,
  { orderId: string; remove_pool?: boolean }
>(
  "adminPayOutOrders/cancelPayOutOrderBySupport",
  async ({ orderId, remove_pool }, { rejectWithValue }) => {
    try {
      return await cancelPayOutOrderBySupportApi(orderId, remove_pool);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type AdminOrdersState = State<{
  payOutOrders: AdminPayOutOrder[] | null;
  modalLoading: boolean;
  count: number;
}>;

const initialState: AdminOrdersState = {
  payOutOrders: null,
  count: 0,
  loading: false,
  error: null,
  modalLoading: false,
};

const adminOrdersSlice = createSlice({
  name: "adminOrders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminPayOutOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminPayOutOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.payOutOrders = action.payload?.pay_out_orders ?? null;
        state.count = action.payload?.count ?? 0;
      })
      .addCase(getAdminPayOutOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(completePayOutOrder.pending, (state) => {
        state.modalLoading = true;
        state.error = null;
      })
      .addCase(completePayOutOrder.fulfilled, (state, action) => {
        state.modalLoading = false;
        console.log(action.payload);
        // store.dispatch(addAlert(action.payload));
      })
      .addCase(completePayOutOrder.rejected, (state, action) => {
        state.modalLoading = false;
        state.error = action.payload as string;
      })
      .addCase(cancelPayOutOrderBySupport.pending, (state) => {
        state.modalLoading = true;
        state.error = null;
      })
      .addCase(cancelPayOutOrderBySupport.fulfilled, (state, action) => {
        state.modalLoading = false;
        console.log(action.payload);
        // store.dispatch(addAlert(action.payload));
      })
      .addCase(cancelPayOutOrderBySupport.rejected, (state, action) => {
        state.modalLoading = false;
        state.error = action.payload as string;
      });
  },
});

export default adminOrdersSlice.reducer;
